__turbopack_context__.v({
  "group": "SearchResults-module__Zk1rwa__group",
  "groupLabel": "SearchResults-module__Zk1rwa__groupLabel",
  "item": "SearchResults-module__Zk1rwa__item",
  "noResults": "SearchResults-module__Zk1rwa__noResults",
});
